import React from 'react'
import { Calendar } from 'primereact/calendar'
import { useField } from 'formik'

// Define shared pt object
const sharedPt = {
  root: { className: 'input-field !text-[12px] !p-0 !h-[30px] flex items-center overflow-hidden' },
  input: {
    root: {
      className:
        '!px-2 !py-0 border-0 !bg-transparent !shadow-none w-full h-full !focus:border-0 !focus:outline-none focus:shadow-none !focus:ring-0 text-[10px] md:text-[12px] flex items-center leading-normal'
    }
  },
  panel: { className: '!min-w-[250px] !w-auto' },
  dayLabel: { className: 'w-[25px] h-[25px] text-[14px]' },
  tableheadercell: { className: '!p-1 text-[14px]' },
  todayButton: { label: { className: '!text-primary !font-[500]' } },
  clearButton: { label: { className: '!text-primary !font-[500]' } }
}

// DatePicker component for Formik usage
const FormikDatePicker = ({
  name,
  label = '',
  placeholder = '',
  className = '',
  showTime = false,
  hourFormat = '24',
  dateFormat = 'dd/mm/yy',
  defaultValue = '',
  timeOnly = false,
  hideErrorText = false,
  onChange,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);
  const isInvalid = Boolean(meta.error && meta.touched);

  const parsedValue = field?.value
    ? field.value instanceof Date
      ? field.value
      : !isNaN(Date.parse(field.value))
      ? new Date(field.value)
      : null
    : null;

  const handleChange = (e) => {
    helpers.setValue(e.value);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${className}`}>
      {label && (
        <label htmlFor={name} className='input-label'>
          {label}
        </label>
      )}
      <Calendar
        timeOnly={timeOnly}
        id={name}
        name={name}
        placeholder={placeholder}
        showTime={showTime}
        hourFormat={hourFormat}
        dateFormat={dateFormat}
        value={parsedValue}
        onChange={handleChange}
        onBlur={() => helpers.setTouched(true)}
        {...props}
        pt={{
          ...sharedPt,
          root: { className: `input-field !text-[12px] !p-0 !h-[30px] flex items-center overflow-hidden ${isInvalid && hideErrorText ? '!border-red-500' : ''}` },
          input: {
            root: {
              className:
                '!px-2 !py-0 border-0 !bg-transparent !shadow-none w-full h-full !focus:border-0 !focus:outline-none focus:shadow-none !focus:ring-0 text-[10px] md:text-[12px] flex items-center leading-normal'
            }
          }
        }}
      />
      {isInvalid && !hideErrorText && (
        <p className='text-sm text-red-500'>{meta.error}</p>
      )}
    </div>
  );
};

// Standalone DatePicker component
const StandaloneDatePicker = ({
  label = '',
  placeholder = '',
  className = '',
  defaultValue = '',
  showTime = false,
  hourFormat = '24',
  dateFormat = 'dd/mm/yy',
  value = null,
  handleChange = () => { },
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${className}`}>
      {label && (
        <label htmlFor='standalone-date-picker' className='input-label'>
          {label}
        </label>
      )}
      <Calendar
        id='standalone-date-picker'
        placeholder={placeholder}
        showTime={showTime}
        hourFormat={hourFormat}
        dateFormat={dateFormat}
        value={value}
        onChange={handleChange}
        {...props}
        pt={sharedPt}
      />
    </div>
  )
}

// DatePicker wrapper
const DatePicker = props => {
  const { useFormik = true } = props

  if (useFormik) {
    return <FormikDatePicker {...props} />
  }

  return <StandaloneDatePicker {...props} />
}

export default DatePicker
